import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);
import FloatingContainer from "../display/FloatingContainer";
import FormGroupHeader from "./FormGroupHeader";
import ErrorSpan from "./ErrorSpan";
import Picker from "./Picker";
import { sanitizeResourceName } from "../../modules/utils";
const FloatingPicker = /*#__PURE__*/ forwardRef(function FloatingPicker({ className = 'input-group__item', clickToUnlock, direction, disabled, disabledText, error, handlePropagation, id, label, name, onClick, options, resourceName, value }, ref) {
    const [showPicker, setShowPicker] = useState(false);
    const inputRef = useRef(null); // Expose inputRef to parent via ref
    useImperativeHandle(ref, () => ({ inputRef }));
    const showPickerHandler = () => { inputRef.current?.blur(); setShowPicker(true); };
    const handleInputClick = () => { if (onClick) {
        onClick();
    }
    else {
        showPickerHandler();
    } };
    const hidePicker = () => { setShowPicker(false); };
    const getGridOffset = () => {
        if (!value) {
            return 1;
        }
        const beginningOfTheMonth = dayjs(new Date(value)).date(1);
        const dayOfWeek = beginningOfTheMonth.isoWeekday(); // 1 (Monday) to 7 (Sunday)
        return dayOfWeek;
    };
    const inputNameValue = `${resourceName}[${name}]`;
    const inputIdValue = `${sanitizeResourceName(resourceName)}_${name}`;
    const displayValue = disabled && disabledText && !value ? disabledText : value;
    const inputClasses = ['form-group__input', 'picker__input'];
    if (showPicker) {
        inputClasses.push('focused');
    }
    const isDisabledWithClickToUnlock = disabled && !clickToUnlock;
    const inputStyle = isDisabledWithClickToUnlock ? { pointerEvents: 'none' } : {};
    const shouldAllowClick = disabled && !clickToUnlock;
    const pickerClasses = ['form-group', 'position-relative'];
    if (error && !disabled) {
        pickerClasses.push('form-group--error');
    }
    return /*#__PURE__*/ React.createElement("div", { className: className, id: id }, /*#__PURE__*/ React.createElement("div", { className: pickerClasses.join(' ') }, /*#__PURE__*/ React.createElement(FormGroupHeader, { label: label }), /*#__PURE__*/ React.createElement("div", { onClick: shouldAllowClick ? handleInputClick : showPickerHandler, style: { cursor: shouldAllowClick ? 'pointer' : 'auto' } }, /*#__PURE__*/ React.createElement("input", { className: inputClasses.join(' '), disabled: disabled && !clickToUnlock, id: inputIdValue, key: "0", name: inputNameValue, readOnly: true, ref: inputRef, style: inputStyle, type: "text", value: displayValue })), /*#__PURE__*/ React.createElement(FloatingContainer, { onClose: hidePicker, direction: direction, open: showPicker }, /*#__PURE__*/ React.createElement(Picker, { getGridOffset: getGridOffset, onChange: handlePropagation, onComplete: hidePicker, options: options })), error && typeof error != 'boolean' && !disabled && /*#__PURE__*/ React.createElement(ErrorSpan, { error: error })));
});
export default FloatingPicker;
